// allowed characters: A-Za-z0-9-._~:/?#[]@!$&'()*+,;= and space
const ALLOWED_CHARS_REGEX = /[^A-Za-z0-9\-._~:/?#[\]@!$&'()*+,;= ]/g;

export const MAX_NICKNAME_LENGTH = 24;
export const MAX_REVOCATION_REASON_LENGTH = 100;
export const MAX_ALIAS_LENGTH = 10;

// matches pattern enforced on the API endpoint: https://code.amazon.com/packages/KuiperIAM-IdentityProviderModel/blobs/mainline/--/types/authn.go
export const sanitizeNickname = (value: string) =>
  value.replace(ALLOWED_CHARS_REGEX, "").slice(0, MAX_NICKNAME_LENGTH);

// matches pattern enforced on the API endpoint: https://code.amazon.com/packages/KuiperIAM-IdentityProviderModel/blobs/mainline/--/types/authn.go
export const sanitizeRevocationReason = (value: string) =>
  value.replace(ALLOWED_CHARS_REGEX, "").slice(0, MAX_REVOCATION_REASON_LENGTH);

// matches pattern enforced on the API endpoint: https://code.amazon.com/packages/KuiperIAM-IdentityProviderModel/blobs/mainline/--/types/authn.go
export const sanitizeAlias = (value: string) =>
  value.replace(/[^a-zA-Z]/g, "").slice(0, MAX_ALIAS_LENGTH);

export const isValidModhex = (value: string) =>
  /^[cbdefghijklnrtuv]*$/.test(value);
